import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: /*#__PURE__*/ _normalizeClass(['g-modal-slide']),
    ref: "modal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onMousedown: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.closeModalOnClickOutside && _ctx.closeModalOnClickOutside(...args))),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(
            //@ts-ignore
            (...args) => (_ctx.closeModalOnEscapeKey && _ctx.closeModalOnEscapeKey(...args)), ["esc"]))
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(['dialog', _ctx.identifierClass, _ctx.modalClasses, _ctx.visible2 ? 'show' : '']),
                    style: _normalizeStyle({ visibility: _ctx.visible ? 'visible' : 'hidden' }),
                    ref: "dialog",
                    tabindex: "-1"
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 6)
            ], 512)
        ], 32))
        : _createCommentVNode("", true);
}
